<template>
  <div class="navbar-container d-flex content align-items-center">
    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link class="nav-link" @click="toggleVerticalMenuActive">
          <feather-icon icon="MenuIcon" size="21" />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div
      class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex"
    >
      <dark-Toggler class="d-none d-lg-block" />
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <div v-if="total > 0">
        <b-nav-item-dropdown
          right
          toggle-class="d-flex align-items-center dropdown-user-link"
          class="dropdown-user"
        >
          <template #button-content>
            <div class="d-sm-flex user-nav">
              <p
                class="user-name font-weight-bolder mb-0 btn btn-danger btn-sm"
              >
                <i class="fa fa-bell"></i>
                {{ total }}
              </p>
            </div>
          </template>

          <b-dropdown-item
            v-if="notifications['devices'] > 0"
            link-class="d-flex align-items-center"
            @click="$router.push('/parents/devices')"
          >
            <span>اجهزة اولياء الامور ({{ notifications["devices"] }})</span>
          </b-dropdown-item>
          <b-dropdown-item
            v-if="notifications['alerts'] > 0"
            link-class="d-flex align-items-center"
            @click="$router.push('/alerts')"
          >
            <span>تنبيهات المشرفين ({{ notifications["alerts"] }})</span>
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </div>
      <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template #button-content>
          <div class="d-sm-flex d-none user-nav">
            <p class="user-name font-weight-bolder mb-0">
              {{ user.name }}
            </p>
            <span class="user-status">{{ user.phone }}</span>
          </div>
          <b-avatar
            size="40"
            variant="light-primary"
            badge
            :src="
              user.image && user.image != ''
                ? user.image
                : require('@/assets/images/avatars/avatar.png')
            "
            class="badge-minimal"
            badge-variant="success"
          />
        </template>

        <b-dropdown-item
          link-class="d-flex align-items-center"
          @click="$router.push('/subscribe')"
        >
          <feather-icon size="16" icon="CheckSquareIcon" class="mr-50" />
          <span>الاشتراك/التجديد</span>
        </b-dropdown-item>

        <b-dropdown-divider />
        <b-dropdown-item
          link-class="d-flex align-items-center"
          @click="$router.push('/profile')"
        >
          <feather-icon size="16" icon="UserIcon" class="mr-50" />
          <span>الملف الشخصي</span>
        </b-dropdown-item>

        <b-dropdown-divider />

        <b-dropdown-item
          link-class="d-flex align-items-center"
          @click="$router.push('/logout')"
        >
          <feather-icon size="16" icon="LogOutIcon" class="mr-50" />
          <span>تسجيل الخروج</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink,
  BNavbarNav,
  BNavItemDropdown,
  BDropdownItem,
  BDropdownDivider,
  BAvatar,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import DarkToggler from "@core/layouts/components/app-navbar/components/DarkToggler.vue";

export default {
  data() {
    return {
      user: {},
      total: 0,
      notifications: {},
    };
  },
  created() {
    if (localStorage.getItem("user")) {
      this.user = JSON.parse(localStorage.getItem("user"));
      if (this.user?.jwt) {
        this.getNotifications();
      }
    }
  },
  methods: {
    getNotifications() {
      var g = this,
        jwt = JSON.parse(localStorage.getItem("user")).jwt;
      $.post(api + "/user/general/notifications", {
        jwt: jwt,
      })
        .then(function (data) {
          var total = 0;
          for (const property in data.response) {
            total = total + data.response[property];
          }
          g.total = total;
          g.notifications = data.response;
          if (
            total != localStorage.getItem("last_notifications") &&
            total > new Number(localStorage.getItem("last_notifications"))
          ) {
            var audio = new Audio(
              "https://cdn-static.brmja.com/storage/uploads/files/620511d8d5536534353593.mp3"
            );
            audio.play();
          }
          localStorage.setItem("last_notifications", total);
          setTimeout(() => {
            g.getNotifications();
          }, 10000);
        })
        .catch(function () {
          setTimeout(() => {
            g.getNotifications();
          }, 5000);
        });
    },
  },
  components: {
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,

    // Navbar Components
    DarkToggler,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
};
</script>
